import { Injectable } from "@angular/core";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { Tradable } from "@models/interfaces/tradable";
import { Helper } from "@helpers/functions";
import { AssetInfo } from "@models/tradable/split/asset_info";
import { Observable, of as observableOf } from "rxjs";
import { catchError } from "rxjs/operators";

/*
	This service separately takes on-demand the asset info translations which have been removed from masterdata
 */

@Injectable({
	providedIn: "root"
})
export class AssetInfoService {
	public constructor(private apicallService: ApicallService) {}

	/*
		Fetches the (translation) information for an asset and updates it. Used in flows which don't require a subscription.
	 */

	public fetchApiInfo(t: Tradable): void {
		if (!t || !!t.getAssetInfo()) {
			return;
		}

		this.getTradablesInfos$([t]).subscribe(
			(assetInfos: AssetInfo[]) => {
				t.setAssetInfo(assetInfos[0]); // Update the asset
			},
			(error) => Helper.handleError(error)
		);
	}

	public getTradablesInfos$(tradables: Tradable[]): Observable<AssetInfo[]> {
		const option = new ApicallOption(AssetInfo, { asset_ids: tradables.map((tradable) => tradable.getId()) });

		return this.apicallService.post("assets/info", option).pipe(
			catchError((error) => {
				Helper.handleError(error);
				return observableOf(null);
			})
		);
	}

	public getTradablesInfosByIds$(ids: string[]): Observable<AssetInfo[]> {
		const option = new ApicallOption(AssetInfo, { asset_ids: ids });

		return this.apicallService.post("assets/info", option).pipe(
			catchError((error) => {
				Helper.handleError(error);
				return observableOf(null);
			})
		);
	}
}
